import './App.css';
import About from './components/About/About';
import AIAssistant from './components/AIAssistant/AIAssistant'; // ← TAMBAHKAN
import CTASection from './components/CTASection/CTASection';
import FAQ from './components/FAQ/FAQ';
import Features from './components/Features/Features';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero';
import JobSection from './components/JobSection/JobSection';
import Navbar from './components/Navbar/Navbar';
import Pricing from './components/Pricing/Pricing';
import TrustedBrands from './components/TrustedBrands/TrustedBrands';

function App() {
  return (
    <div className="App bg-white text-gray-900 antialiased">
      {/* ===== NAVIGATION ===== */}
      <Navbar />

      {/* ===== HERO SECTION ===== */}
      <Hero />

      {/* ===== TRUSTED BRANDS ===== */}
      <TrustedBrands />

      {/* ===== JOB SECTION ===== */}
      <JobSection />

      {/* ===== FEATURES SECTION ===== */}
      <Features />

      {/* ===== PRICING SECTION ===== */}
      <Pricing />

      {/* ===== ABOUT SECTION ===== */}
      <About />

      {/* ===== FAQ SECTION ===== */}
      <FAQ />

      {/* ===== CTA SECTION ===== */}
      <CTASection />

      {/* ===== FOOTER ===== */}
      <Footer />

      {/* ===== AI ASSISTANT (FLOATING BOTTOM RIGHT) ===== */}
      <AIAssistant />
    </div>
  );
}

export default App;
